import { render, staticRenderFns } from "./LabelManagement.vue?vue&type=template&id=268ecd5a"
import script from "./LabelManagement.vue?vue&type=script&lang=js"
export * from "./LabelManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports